/* eslint-disable no-unused-vars */
<template>
  <div class="dispute-bulk">
    <div
      v-if="!isEmpty(bulkUpdatedInvoices) || !isEmpty(bulkFailedInvoices)"
      class="dispute-bulk__tabs">
      <Tabs :items="disputeBulkTabItems" @onClick="onTabActivated" />

      <div class="dispute-bulk__sub-tabs">
        <div
          v-if="currentSelectedTab === 'SUCCESS'"
          class="dispute-bulk__sub-tabs__success">
          <Table
            class="dispute-bulk__sub-tabs__success-table"
            :default-columns="bulkDisputeSuccessColumns"
            :row-data="bulkUpdatedInvoices"
            primary-key="invoiceNumber"
            cell-background="#fff"
            header-cell-background="#f7f7f7"
            no-data-message="Invoice breakup data is not present"></Table>
        </div>
        <div
          v-if="currentSelectedTab === 'FAILED'"
          class="dispute-bulk__sub-tabs__failed">
          <Table
            class="dispute-bulk__sub-tabs__failed-table"
            :default-columns="bulkDisputeFailedColumns"
            :row-data="bulkFailedInvoices"
            primary-key="invoiceNumber"
            cell-background="#fff"
            header-cell-background="#f7f7f7"
            no-data-message="Invoice breakup data is not present"></Table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Constants
import {
  disputeBulkTabItems,
  bulkDisputeSuccessColumns,
  bulkDisputeFailedColumns,
} from "@/config/constant.js";
import { isEmpty } from "@/utils/helpers.js";
export default {
  name: "DisputeBulkTabs",
  components: {},
  props: {
    bulkCreatedId: {
      type: String,
      default: "",
    },
    bulkProcessingCompleted: {
      type: Boolean,
      default: false,
    },
    bulkUpdatedInvoices: {
      type: Array,
      default: () => [],
    },
    bulkFailedInvoices: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      disputeBulkTabItems,
      currentSelectedTab: "SUCCESS",
      bulkDisputeSuccessColumns,
      bulkDisputeFailedColumns,
      isEmpty,
    };
  },
  computed: {
    bulkCreatedStatus() {
      return this.bulkProcessingCompleted ? "completed" : "in progress";
    },
    getBulkCreationTitle() {
      return this.bulkProcessingCompleted
        ? "Bulk Dispute operation is successful"
        : "Bulk Dispute operation is in progress";
    },
  },
  methods: {
    onTabActivated({ selectedItemId, updatedTabData }) {
      this.currentSelectedTab = selectedItemId;
      this.disputeBulkTabItems = updatedTabData;
    },
  },
};
</script>

<style lang="scss" scoped>
.dispute-bulk {
  &__info {
    margin-top: 16px;
  }
  &__sub-tabs {
    padding: 24px;
    min-height: 120px;
    background: var(--Gray-50);
    border: 1px solid #d8d8d8;
    border-top: none;
    box-shadow: 0 1px 5px rgb(0 0 0 / 4%), 0 3px 1px -2px rgb(0 0 0 / 4%),
      0 2px 2px rgb(0 0 0 / 4%);
    &__success-table,
    &__failed-table {
      overflow-y: auto;
      border: 1px solid var(--Gray-700);
    }
  }
}
</style>
